export default __webpack_public_path__ + "static/media/kendall.19201574.jpg";